import { render, staticRenderFns } from "./CustomerFundingKA.vue?vue&type=template&id=b10940ce&scoped=true"
import script from "./CustomerFundingKA.vue?vue&type=script&lang=ts"
export * from "./CustomerFundingKA.vue?vue&type=script&lang=ts"
import style0 from "./CustomerFundingKA.vue?vue&type=style&index=0&id=b10940ce&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b10940ce",
  null
  
)

export default component.exports